module.exports = __webpack_public_path__ + "brand-mark-71a8063d.svg";